export default {
    colors: {
        backgroundColor: "#fafafa",
        white: "#ffffff"
    }
};
